import * as z from "zod";
import { gql } from "graphql-request";

export const Global = z.object({
  key: z.string().nullable(),
  value: z.string().nullable(),
});

export const GlobalFragment = gql`
  fragment GlobalFragment on Global {
    key
    value
  }
`;
